import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-group list-group-flush" }
const _hoisted_2 = ["onClick", "onMouseout", "onMouseover"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter) => {
      return (_openBlock(), _createElementBlock("a", {
        key: filter.id,
        class: _normalizeClass(["list-group-item list-group-item-action d-flex align-items-center", { active: filter.id === $props.selected }]),
        href: "#",
        onClick: _withModifiers($event => ($props.action(filter.id)), ["stop","prevent"]),
        onMouseout: $event => ($options.hover_cancel(filter.id)),
        onMouseover: $event => ($options.hover_start(filter.id))
      }, [
        (filter.icon)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              class: "me-1",
              name: filter.icon
            }, null, 8 /* PROPS */, ["name"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", {
          innerHTML: filter.title
        }, null, 8 /* PROPS */, _hoisted_3),
        (filter.badge)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "position-absolute end-0 me-2 bg-light text-primary badge rounded-pill",
              innerHTML: filter.badge
            }, null, 8 /* PROPS */, _hoisted_4))
          : (_openBlock(), _createBlock(_component_icon, {
              key: 2,
              class: "position-absolute end-0 me-2",
              name: "CHEVRON_RIGHT"
            }))
      ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}